import { render, staticRenderFns } from "./MGate.vue?vue&type=template&id=996cfa28&scoped=true"
import script from "./MGate.vue?vue&type=script&lang=js"
export * from "./MGate.vue?vue&type=script&lang=js"
import style0 from "./MGate.vue?vue&type=style&index=0&id=996cfa28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996cfa28",
  null
  
)

export default component.exports